import { StripePrice } from "src/types"

interface PriceForCurrencyResult {
  price: number
  currency: string
}

export default function getPriceForCurrency(
  stripePrice: StripePrice | undefined,
  preferredCurrency: string,
): PriceForCurrencyResult | null {
  if (!stripePrice) return null

  const hasCurrencyOption =
    !!stripePrice.currency_options?.[preferredCurrency]?.unit_amount_decimal

  const price = parseFloat(
    hasCurrencyOption
      ? stripePrice.currency_options[preferredCurrency].unit_amount_decimal
      : stripePrice.unit_amount_decimal,
  )

  if (!price) return null

  const currency = hasCurrencyOption ? preferredCurrency : stripePrice.currency

  return { price, currency }
}
